import { useAuthContext } from './AuthContext'

/**
 * Convenience hook — drop-in replacement for useSession().
 *
 * Exposes: status, session, signIn, signInWithToken, signOut, refresh
 */
export function useAuth() {
  return useAuthContext()
}
